import { useTranslation } from "react-i18next";
import { PROCESS_STEPS } from "../constants";
import { ProcessStepInfo } from "./ProcessStepInfo";

export const ProcessSteps = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-10 max-w-200 w-full">
      {PROCESS_STEPS.map(({ id, title, info }) => (
        <div key={id}>
          <h4
            className="text-2xl text-purple-base font-monument-extended pb-7"
            id={id as string}
          >
            {t(title.i18nKey)}
          </h4>

          <div className="flex flex-col gap-7">
            {info.map((item) => (
              <ProcessStepInfo key={item.id} {...item} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
